import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const tokenFromCookie = Cookies.get("token");
const userFromCookie = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: tokenFromCookie || null,
    user: userFromCookie || null,
  },
  reducers: {
    login: (state, action) => {
      const { token, user } = action.payload;

      state.token = token;
      state.user = user;

      // ✅ Save to cookies
      Cookies.set("token", token, { expires: 7 }); // 7 days
      Cookies.set("user", JSON.stringify(user), { expires: 7 });
    },

    logout: (state) => {
      state.token = null;
      state.user = null;

      // ✅ Remove cookies
      Cookies.remove("token");
      Cookies.remove("user");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;